import { all, call, put, takeLatest } from "redux-saga/effects";
import { passengerActions } from "../slices/passengerSlice";
import passengerService from "../../services/passengerService";

function* cancelledPassengerSaga() {
  try {
    const data = yield call(passengerService.getCancelledPassenger);

    yield put(passengerActions.cancelledPassengerSuccess(data));
  } catch (e) {
    yield put(passengerActions.cancelledPassengerError(e.response.data));
  }
}

export default function* passengerSaga() {
  yield all([
    takeLatest("passenger/cancelledPassengerFetch", cancelledPassengerSaga),
  ]);
}
